import { render, staticRenderFns } from "./vTabbedContent.vue?vue&type=template&id=3694f65e&scoped=true"
import script from "./vTabbedContent.vue?vue&type=script&lang=ts"
export * from "./vTabbedContent.vue?vue&type=script&lang=ts"
import style0 from "./vTabbedContent.vue?vue&type=style&index=0&id=3694f65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694f65e",
  null
  
)

export default component.exports